import { useContext } from 'react';
import { AppInfoContext, type AppInfoContextType } from './appInfoContextObject';

/**
 * Access the shared /api/info payload. Must be used under <AppInfoProvider>.
 */
export function useAppInfo(): AppInfoContextType {
  const ctx = useContext(AppInfoContext);
  if (!ctx) {
    throw new Error('useAppInfo must be used within an AppInfoProvider');
  }
  return ctx;
}
